/**
 * Tracks whether the document is being torn down, so an in-flight request the
 * browser kills during unload can be told apart from a genuine connectivity
 * failure (COI-716).
 *
 * A cross-document navigation — a logout redirect (`window.location.href` in
 * ApolloGraphqlProvider), an Auth0 redirect, the PWA update reload, a typed
 * URL, closing the tab — aborts every in-flight `fetch` while every component
 * is still mounted and still observing its query. Without this signal those
 * aborts look identical to "the user's network broke".
 *
 * `pagehide` rather than `beforeunload`: `beforeunload` also fires for a
 * navigation the user then cancels (which would leave the flag stuck on), and
 * iOS Safari may never fire it. `pagehide` fires for every teardown.
 *
 * A page put into the back/forward cache can come back, so `pageshow` clears
 * the flag — otherwise a restored tab would silently stop reporting query
 * errors for the rest of its life.
 */
let pageUnloading = false;

export const isPageUnloading = (): boolean => pageUnloading;

if (typeof window !== 'undefined') {
  window.addEventListener('pagehide', () => {
    pageUnloading = true;
  });
  window.addEventListener('pageshow', () => {
    pageUnloading = false;
  });
}
